enum CcsVariablePrefix {
  SDE = 'sde',
  CUSTOM = 'custom',
  CONVERSATION = 'conversation',
}

enum CcsExceptionMapVariablePrefix {
  SDE = 'SDE',
  CUSTOM = 'Custom',
  CONVERSATION = 'Conversation',
}

export { CcsVariablePrefix, CcsExceptionMapVariablePrefix };
